import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "result-content" }
const _hoisted_2 = {
  key: 0,
  class: "slider"
}
const _hoisted_3 = { class: "slides" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "slider"
}
const _hoisted_6 = { class: "slides" }
const _hoisted_7 = { id: "slide-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "product_info animate__animated animate__bounce" }
const _hoisted_10 = { class: "brand" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = {
  key: 2,
  class: "action-btn"
}
const _hoisted_14 = {
  key: 4,
  class: "action-btn"
}

import { computed, ref } from "vue";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonList,
  IonItem,
  modalController,
} from "@ionic/vue";
import { heart, heartOutline } from "ionicons/icons";
import { closeOutline } from "ionicons/icons";
import { useUserStore } from "@/store/modules/user";
import { useBrandStore } from "@/store/modules/brand";
import { useProductStore } from "@/store/modules/product";
import ProductReviewComponent from "@/components/Product/ProductReviewComponent.vue";
import { presentToastWithOptions, toDataURL } from "@/utils/functions";
import { useFavorite } from "@/hooks/useFavorite";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalBarcodeScanResult',
  props: ["barcodeResult", "isFromDB"],
  setup(__props) {

const props = __props;
const isLoading = ref(false);
const userStore = useUserStore();
const productStore = useProductStore();
const brandStore = useBrandStore();
const { favorite, onAddFavorite, onDeleteFavorite, getFavorite } = useFavorite();
const user = computed(() => userStore.user);
const isFav = computed(() => favorite.value?.id ?? false);
const favoriteIcon = computed(() => (isFav.value ? heart : heartOutline));
const favoriteId = computed(() => favorite.value?.id);
const data = computed(() => {
  return {
    type: "product",
    product: "id" || "",
    user: user.value,
  };
});

const cancel = () => modalController.dismiss(false, "cancel");

const addSuggestProduct = async () => {
  isLoading.value = true;
  const brand_result = await brandStore.axCreateBrand({
    name: props.barcodeResult?.brand,
  });

  if (brand_result) {
    // toDataURL(props.barcodeResult?.images[0], (result: any) =>
    //   console.log("url-result==>", result)
    // );
    const data = {
      title: props.barcodeResult?.title,
      sku: props.barcodeResult?.barcode_number,
      url: props.barcodeResult?.images[0],
      description: props.barcodeResult?.description,
      brand: brand_result,
      status: "active",
    };
    const product_result = await productStore.axCreateProduct(data, userStore.user.id);
    isLoading.value = false;
    if (product_result) modalController.dismiss(true, "ok");
    else presentToastWithOptions("Creating the Suggested Product is failed", "danger");
  } else {
    isLoading.value = false;
  }
};

const onAddFav = async () => {
  if (!isFav.value) {
    await onAddFavorite(data.value);
  } else {
    await onDeleteFavorite(favoriteId.value || "", data.value?.type);
  }
  await getFavorite(data.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "review-title" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Scan Results")
                ])),
                _: 1,
                __: [1]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.barcodeResult.images.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.barcodeResult?.images, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        id: "slide-1",
                        key: n
                      }, [
                        _createElementVNode("img", { src: n }, null, 8, _hoisted_4)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.barcodeResult.images.length == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        src: __props.barcodeResult?.images[0]
                      }, null, 8, _hoisted_8)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, "By: " + _toDisplayString(__props.barcodeResult?.brand), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(__props.barcodeResult?.title), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(__props.barcodeResult?.description), 1),
              (__props.isFromDB)
                ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.barcodeResult?.reviews, (review) => {
                        return (_openBlock(), _createBlock(_unref(IonItem), {
                          key: review?.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ProductReviewComponent, { review: review }, null, 8, ["review"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (__props.isFromDB && __props.barcodeResult?.status === 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_unref(IonButton), { onClick: onAddFav }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: favoriteIcon.value,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _cache[2] || (_cache[2] = _createTextVNode(" Favorite this product "))
                    ]),
                    _: 1,
                    __: [2]
                  })
                ]))
              : (__props.isFromDB && __props.barcodeResult?.status === 'pending')
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 3,
                    disabled: "",
                    shape: "round",
                    expand: "full",
                    class: "disable-btn"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Product Pending Review ")
                    ])),
                    _: 1,
                    __: [3]
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_unref(IonButton), { onClick: addSuggestProduct }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Suggest this product")
                      ])),
                      _: 1,
                      __: [4]
                    })
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})